import { useRef } from "react";
import { motion, useInView } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 36, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.85, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskedLines = ({
  lines,
  as: Tag = "h2",
  className = "",
  lineClassName = "",
  delay = 0,
  inView = true,
}) => {
  const ref = useRef(null);
  const seen = useInView(ref, { once: true, margin: "-60px" });
  const show = inView ? seen : true;

  return (
    <Tag ref={ref} className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.09em] -mb-[0.09em]">
          <motion.span
            className={`block will-change-transform transform-gpu ${lineClassName}`}
            initial={false}
            animate={{ y: show ? "0%" : "112%" }}
            transition={{ duration: 0.95, delay: show ? delay + i * 0.13 : 0, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};

export const ChapterHeading = ({ index, eyebrow, lines, sub, dark = false, align = "left" }) => (
  <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    <Reveal>
      <div className={`flex items-center gap-4 ${align === "center" ? "justify-center" : ""}`}>
        <span className="font-mono2 text-xs tracking-[0.35em] text-[var(--brand)]">{index}</span>
        <span className="h-px w-12 bg-[var(--brand)]" />
        <span className={`font-mono2 text-[11px] uppercase tracking-[0.3em] ${dark ? "text-sage" : "text-[var(--muted)]"}`}>
          {eyebrow}
        </span>
      </div>
    </Reveal>
    <MaskedLines
      lines={lines}
      delay={0.1}
      className={`mt-6 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.05] ${dark ? "text-offwhite" : "text-[var(--ink)]"}`}
    />
    {sub && (
      <Reveal delay={0.3}>
        <p className={`mt-6 text-base sm:text-lg leading-relaxed ${dark ? "text-sage/80" : "text-[var(--muted)]"}`}>
          {sub}
        </p>
      </Reveal>
    )}
  </div>
);
